<template>
  <div class="mainview">
    <div class="contentBody">
      <div class="mb20">
        <el-button type="primary" @click="addLebel(0)" size="small">新增分组</el-button>
      </div>
      <div class="table_wrap">
        <el-table :data="tagList" style="width: 100%">
          <el-table-column prop="name" label="分组名称" width="200">
          </el-table-column>
          <el-table-column label="标签">
            <template slot-scope="scope">
              <span>
              <el-tag
                      :key="tag.name"
                      v-for="(tag, index) in scope.row.tag"
                      closable
                      :disable-transitions="false"
                      color="#efeff4"
                      @close="handleClose(scope.$index,index)"
                      type="info"
              >{{tag.name}}
              </el-tag>
                </span>
              <el-input
                      class="input-new-tag"
                      v-if="scope.row.inputVisible"
                      v-model="scope.row.inputValue"
                      :ref="'saveTagInput'+scope.$index"
                      size="small"
                      @keyup.enter.native="handleInputConfirm(scope.$index)"
                      @blur="handleInputConfirm(scope.$index)"
              ></el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showInput(scope.$index)">+ 添加标签
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <span class="action_btn" @click="detelLebel(scope.row.id,scope.row.name)">删除</span>
              <span class="action_btn" @click="addLebel(1,scope.row)">编辑</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <addColumnLebel :visible.sync="addcolumnlebel" :dialogType="dialogType" :dialogContent="dialogContent"
                    v-if="addcolumnlebel" @initFn="InitFn"></addColumnLebel>
  </div>
</template>
<script>
  import api from "@/api.js";
  import addColumnLebel from "@/components/dialog/addColumnLebel.vue";

  export default {
    name: "custom",
    components: {
      addColumnLebel
    },
    data() {
      return {
        tagList: [],
        inputVisible: false,
        inputValue: "",
        addcolumnlebel: false,
        dialogType: 0,
        dialogContent: null
      };
    },
    created() {
      this.InitFn();
    },
    methods: {
      //初始化请求
      InitFn() {
        this.axios
            .post(api.tag_index, {})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in response.data.list) {
                  response.data.list[i].inputVisible = false
                  response.data.list[i].inputValue = ''
                }
                this.tagList = response.data.list
                // let title = '添加栏目成功!'
                // if (this.dialogType === 1) {
                //   title = '编辑栏目成功!'
                // }
                // this.$message({
                //   type: 'success',
                //   message: title
                // });
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleInputConfirm(index) {
        
        if (this.tagList[index].inputValue) {
          this.axios
              .post(api.tag_add, {name: this.tagList[index].inputValue, group_id: this.tagList[index].id})
              .then(response => {
                if (response.data.code == 0) {
                  this.tagList[index].inputVisible = false;
                  this.tagList[index].inputValue = ''
                  this.InitFn()
                  this.$message({
                    message: '添加成功',
                  });
                } else {
                }
              })
              .catch(response => {
              });
        } else {
          this.tagList[index].inputVisible = false;
          this.tagList[index].inputValue = ''
        }
      },
      showInput(index) {
        let saveTagInput = 'saveTagInput' + index
        this.tagList[index].inputVisible = true;
        this.$nextTick(() => {
          this.$refs[saveTagInput].$refs.input.focus();
        });
      },
      addLebel(option, val) {
        this.addcolumnlebel = true;
        this.dialogType = option;
        if (option === 1) {
          this.dialogContent = val
        } else {
          this.dialogContent = ''
        }
      },
      // 删除
      handleClose(index_, index) {
        let _this = this
        this.$alert('<i class="el-icon-info"></i>确定删除 ' + name + ' 标签', '', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '删除',
          cancelButtonText: '取消',
        }).then(() => {
          _this.axios
              .post(api.tag_delete, {tags_id: _this.tagList[index_].tag[index].id})
              .then(response => {
                if (response.data.code == 0) {
                  _this.InitFn()
                  _this.$message({
                    message: '删除成功',
                  });
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });
      },
      detelLebel(id, name) {
        let _this =this
        this.$alert('<i class="el-icon-info"></i>确定删除 ' + name + ' 分组</br>该分组下的标签将一并删除', '', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '删除',
          cancelButtonText: '取消',
        }).then(() => {
          _this.axios
              .post(api.tag_group_delete, {group_id: id})
              .then(response => {
                if (response.data.code == 0) {
                  _this.InitFn()
                  _this.$message({
                    message: '删除成功',
                  });
                } else {
                }
              })
              .catch(response => {
              });
        }).catch(() => {
        });

      }
    }
  };
</script>


